import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PageContent from '../Content'

export default class Database extends PageContent {

    // TODO: load baseName from config.json
    async loadItems() {
        const getItems = async () => {
            const response = await fetch(
                process.env.PUBLIC_URL + '/data/database.json'
            );
            const data = await response.json();
            this.setItems(data);
        };
      
        await getItems();
    }

    runCustomFilter() {
        let filter;

        const compare = this.wholeWords?
            (str, substr) => str.toLocaleLowerCase() === substr:
            (str, substr) => str.toLocaleLowerCase().includes(substr);

        if(this.table && this.field) {
            filter = item => 
                (compare(item.oldTableName, this.table) || compare(item.tableName, this.table)) && 
                (compare(item.oldFieldName, this.field) || compare(item.fieldName, this.field)
            );
        } else if(this.table) {
            filter = item => compare(item.oldTableName, this.table) || compare(item.tableName, this.table);
        } else if(this.field) {
            filter = item => compare(item.oldFieldName, this.field) || compare(item.fieldName, this.field)
        } else {
            filter = item => true;
        }
        this.setFilter(filter);
    }

    getNav() {
        return (
            <Container className='mt-4'>
                <Row>
                    <Col>
                        <Form.Control 
                            placeholder='Tabulka'
                            onChange={e => this.table = e.target.value.toLocaleLowerCase()} 
                            onKeyDown={(e) => { if(e.key === 'Enter') this.runCustomFilter(); }} 
                        />
                    </Col>
                    <Col>
                        <Form.Control 
                            placeholder='Pole'
                            onChange={e => this.field = e.target.value.toLocaleLowerCase()} 
                            onKeyDown={(e) => { if(e.key === 'Enter') this.runCustomFilter(); }} 
                        />
                    </Col>
                </Row>
                <Row className='mt-4'>
                    <Col className='text-end'>
                        <Button variant='success' onClick={() => this.runCustomFilter()}>Hledat</Button>
                    </Col>
                    <Col className='align-middle' style={{display: 'flex', alignItems: 'center'}}>
                        <Form.Check label='Celá slova' onClick={e => this.wholeWords = e.target.value}/>
                    </Col>
                </Row>
            </Container>
        );
    }

    getTableHeader() {
        return (
            <tr>
                <th className='col-md-1'>Stará tabulka</th>
                <th className='col-md-1'>Nová tabulka</th>
                <th className='col-md-1'>Staré pole</th>
                <th className='col-md-1'>Nové pole</th>
            </tr>
        );
    }

    getRow(item, index) {
        return (
            <tr key={index}>
                <td >{item.oldTableName}</td>
                <td>{item.tableName}</td>
                <td>{item.oldFieldName}</td>
                <td>{item.fieldName}</td>
            </tr>
        );
    }
}